import React from 'react';

const URL_REGEX = /(https?:\/\/[^\s<>\"')\]]+)/g;

/**
 * Renders text with clickable links. URLs are detected and rendered as <a> tags.
 * In Telegram WebApp, links open via WebApp.openLink for proper in-app behavior.
 */
function LinkifyText({ text, className, onClick }) {
  const parts = text.split(URL_REGEX);

  const hasLinks = parts.some((part, i) => i % 2 === 1);
  if (!hasLinks) {
    return (
      <span className={className} onClick={onClick}>
        {text}
      </span>
    );
  }

  const handleLinkClick = (e, url) => {
    e.stopPropagation();
    e.preventDefault();

    if (window.Telegram?.WebApp?.openLink) {
      window.Telegram.WebApp.openLink(url, { try_instant_view: false });
    } else {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <span className={className} onClick={onClick}>
      {parts.map((part, i) => {
        if (i % 2 === 1) {
          // This is a URL match
          return (
            <a
              key={i}
              href={part}
              className="task-link"
              onClick={(e) => handleLinkClick(e, part)}
              rel="noopener noreferrer"
            >
              {part}
            </a>
          );
        }
        return part;
      })}
    </span>
  );
}

export default LinkifyText;
